import { render, staticRenderFns } from "./ModalTips.vue?vue&type=template&id=5db1e905&scoped=true&"
import script from "./ModalTips.vue?vue&type=script&lang=js&"
export * from "./ModalTips.vue?vue&type=script&lang=js&"
import style0 from "./ModalTips.vue?vue&type=style&index=0&id=5db1e905&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db1e905",
  null
  
)

export default component.exports